export function formatProductRating(value: number, locale: string = "de-DE"): string {
  const rounded = Math.round(value * 10) / 10;
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(rounded);
}

/**
 * Extracts the country code from a marketplace ID string.
 *
 * The function assumes the marketplace ID follows a format where the country code
 * is located at positions 5-7 (zero-indexed substring from index 5 to 7) "EBAY-DE" or "EBAY_DE".
 *
 * @param marketplaceId - The marketplace identifier string to extract the country code from.
 *                        If undefined or null, defaults to "DE".
 * @returns The two-character country code extracted from the marketplace ID,
 *          or "DE" if the marketplace ID is undefined or null.
 *
 * @example
 * ```typescript
 * extractCountryCodeFromMarketplaceId("EBAY-DE"); // Returns "DE"
 * extractCountryCodeFromMarketplaceId(undefined); // Returns "DE"
 * ```
 */
export function extractCountryCodeFromMarketplaceId(marketplaceId?: string): string {
  if (!marketplaceId || marketplaceId.length < 7) {
    return "DE";
  }
  return marketplaceId.substring(5, 7);
}
